import { useCallback } from 'react';
import { useCreateClassUserSessionMutation } from '@/apollo/gql/generated/graphql';
import { useRecoilValue, useRecoilState } from 'recoil';
import {
	classSlugAtom,
	connectionIdAtom,
	viewerIdAtom,
} from '@/recoil/atom/globalState';

const useCreateClassUserSession = () => {
	const [createClassUserSession] = useCreateClassUserSessionMutation();
	const viewerId = useRecoilValue(viewerIdAtom);
	const [otConnectionId, setOtConnectionId] = useRecoilState(connectionIdAtom);
	const slug = useRecoilValue(classSlugAtom);

	const createUserSession = useCallback(
		(sessionId, connectionId) => {
			if (otConnectionId !== connectionId) {
				createClassUserSession({
					variables: {
						input: {
							sessionId,
							connectionId,
							classSlug: slug,
							userId: viewerId,
							connectedAt: new Date().toString(),
						},
					},
					onCompleted: () => {
						setOtConnectionId(connectionId);
					},
				});
			}
		},
		[createClassUserSession, otConnectionId, setOtConnectionId, slug, viewerId]
	);

	return { createUserSession, otConnectionId };
};

export default useCreateClassUserSession;
